import { useIFrameFocusDispatch } from './useIFrameFocusDispatch';
import { useIFrameListener } from './useIFrameListener';

/**
 * It enabables a interval to check if the iframe is focused and executes the callback function.
 */
export var useOnIFrameFocus = function useOnIFrameFocus(enableFrameFocusDispatch, targetDocument, cb) {
  useIFrameFocusDispatch(enableFrameFocusDispatch, targetDocument);
  useIFrameListener(enableFrameFocusDispatch, cb, targetDocument);
};
//# sourceMappingURL=useOnIFrameFocus.js.map
